import { render, staticRenderFns } from "./LgpdDialog.vue?vue&type=template&id=2aec6fdc&scoped=true&"
import script from "./LgpdDialog.vue?vue&type=script&lang=js&"
export * from "./LgpdDialog.vue?vue&type=script&lang=js&"
import style0 from "./LgpdDialog.vue?vue&type=style&index=0&id=2aec6fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec6fdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
